export interface AppFeature {
    __typename: 'AppFeature';
    featureId: string;
    condition: string;
}

export const dataIdFromAppFeature = (feature: AppFeature) => {
    return `AppFeature:${feature.featureId}`;
};
